import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import ResultSection from './ResultSection';
import HowToUse from './HowToUse';
import FAQ from './FAQ';
import TagInputSection from './TagInputSection';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TagGenerator = () => {
  const [inputText, setInputText] = useState('');
  const [advancedSeo, setAdvancedSeo] = useState(false);
  const [language, setLanguage] = useState('English');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleGenerate = async (text = inputText) => {
    let inputToUse = inputText;
    if (typeof text === 'string') {
        inputToUse = text;
        setInputText(text);
    }
    
    if (!inputToUse.trim()) {
      toast.error('Please enter a video title or description');
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/generate-tags`, {
        input_text: inputToUse,
        advanced_seo: advancedSeo,
        language: language
      });
      setResult(response.data);
      toast.success('Tags generated successfully');
    } catch (error) {
      toast.error('Failed to generate tags. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const examples = [
    "minecraft",
    "learn react in 2026",
    "top 10 travel destinations",
    "fitness for beginners"
  ];

  return (
    <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12 lg:py-20">
      <div className="text-center mb-12 md:mb-16 space-y-4 md:space-y-6">
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold tracking-tighter leading-tight px-4">
          Generate tags for your <br className="hidden sm:block" />
          <span className="text-foreground">YouTube videos</span>
        </h2>
        <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-2xl mx-auto font-light px-4">
          Quickly and easily find tags and improve discoverability with the powerful SuperTags.
        </p>
      </div>

      <div className="space-y-12">
        <TagInputSection 
          inputText={inputText} 
          setInputText={setInputText} 
          handleGenerate={handleGenerate} 
          loading={loading} 
          advancedSeo={advancedSeo} 
          setAdvancedSeo={setAdvancedSeo} 
          language={language} 
          setLanguage={setLanguage} 
          examples={examples} 
        />

        <ResultSection result={result} />

        {/* Affiliate Banner - Hidden on mobile for better UX */}
        <div className="hidden md:flex justify-center mt-16 relative group">
          <a 
            href="https://vidiq.com/FuturisticAI" 
            target="_blank" 
            rel="noopener noreferrer"
            className="block w-full max-w-3xl overflow-hidden rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1"
          >
            <div className="absolute inset-0 bg-accent/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none rounded-2xl"></div>
            <img 
              src="https://customer-assets-4nw71qhi.emergentagent.net/job_vidtags/artifacts/mz2pyt7m_728x90%20%281%29.png" 
              alt="Supercharge your YouTube channel with vidIQ" 
              className="w-full h-auto object-cover"
            />
          </a>
        </div>
      </div>

      <HowToUse />
      <FAQ />
    </div>
  );
};

export default TagGenerator;